module.exports = __webpack_public_path__ + "static/media/external_link.3f11b597.svg";